import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const DesiginationClient = () => {
  return (
    <SettingsMetaData propertyName={"Designation_Client"} viewPropertyName={"Designation"} />
  );
};
export default DesiginationClient;